import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Provider } from "react-redux";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { handleKeyboardEvent } from "./utils";
import { unregister } from "./serviceWorkerRegistration.js"

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

document.addEventListener("keydown", handleKeyboardEvent);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
unregister();
